import { render, staticRenderFns } from "./ProductOsTypeRelate.vue?vue&type=template&id=94349aea"
import script from "./ProductOsTypeRelate.vue?vue&type=script&lang=js"
export * from "./ProductOsTypeRelate.vue?vue&type=script&lang=js"
import style0 from "./ProductOsTypeRelate.vue?vue&type=style&index=0&id=94349aea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports